<template>
  <div v-show="isShown" class="z-navbar fixed bottom-0 w-full bg-red00 hidden md:block">
    <div class="container min-h-30 mx-auto flex relative">
      <div class="absolute left-0 bottom-0 w-148px">
        <etg-img :src="smartBannerImgPath" alt="smart-banner-phone" />
      </div>

      <div class="centerContent flex items-center flex-1 py-4">
        <div class="mr-6 flex-1">
          <p class="text-xl mb-1 font-bold">{{ $t('smart.banner.title') }}</p>
          <p class="text-lg">{{ downloadPromoText }}</p>
        </div>

        <div class="hidden mr-4 xl:flex xl:gap-2">
          <a v-for="item in appIcons" :key="item.name" :href="item.href" target="_blank" :aria-label="item.name">
            <etg-img class="w-30" :src="item.src" :alt="item.name" />
          </a>
        </div>

        <div class="bg-white p-2 rounded-2 xl:mr-13">
          <QrCode :value="unifiedLink" :size="80" :image-settings="imageSettings" />
        </div>
      </div>

      <div class="relative w-30 hidden xl:block">
        <etg-img class="w-30 absolute bottom-0" src="/images/smart-banner-gift.svg" />
      </div>

      <svg-icon name="cancel" class="relative top-3 w-10 h-10 p-2 -mr-2 cursor-pointer" @click="handleClose" />
    </div>
  </div>
</template>

<script setup lang="ts">
import QrCode from 'qrcode.vue'

const { appIcons, unifiedLink } = useDownloadLinks()
const { downloadPromoText, smartBannerImgPath } = useNewUserGift()

const hasSmartBannerClosedCookie = useHasSmartBannerClosedCookie()

const imageSettings = ref({
  src: '/images/logo-red.png',
  height: 7,
  width: 20,
  excavate: true,
})

const isShown = computed(() => !hasSmartBannerClosedCookie.value)

function handleClose() {
  hasSmartBannerClosedCookie.value = true
}
</script>

<style lang="scss" scoped>
.centerContent {
  /* reserve space for 148px(img) + 24px(margin-right of img) */
  margin-left: 172px;
}
</style>
